import {
  BaseAmazonHandler,
  IAmazonRegionDefinition
} from '@portal/app/dashboard/integrations/shared/vendor-handlers/base-amazon-handler';
import { IVendorOAuthConfirmationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorOAuthConfirmationRequest';
import { VendorIdSource } from '@portal/app/dashboard/integrations/shared/constants';

export class AmazonVendorHandler extends BaseAmazonHandler {
  private static readonly REGION_CONFIG: Record<
    string,
    IAmazonRegionDefinition
  > = {
    NA: {
      authUrl: 'https://vendorcentral.amazon.com/apps/authorize/consent',
      apiUrl: 'https://sellingpartnerapi-na.amazon.com',
      label: 'North America (US, CA, MX, BR)'
    },
    EU: {
      authUrl: 'https://vendorcentral.amazon.co.uk/apps/authorize/consent',
      apiUrl: 'https://sellingpartnerapi-eu.amazon.com',
      label: 'Europe (UK, DE, FR, IT, ES, +)'
    },
    FE: {
      authUrl: 'https://vendorcentral.amazon.co.jp/apps/authorize/consent',
      apiUrl: 'https://sellingpartnerapi-fe.amazon.com',
      label: 'Far East (JP, AU, SG)'
    }
  };

  static getAvailableRegions() {
    return BaseAmazonHandler.buildAvailableRegions(
      AmazonVendorHandler.REGION_CONFIG
    );
  }

  protected getVendorId(): keyof typeof VendorIdSource {
    return 'amazon-vendor';
  }

  protected getRegionConfig(): Record<string, IAmazonRegionDefinition> {
    return AmazonVendorHandler.REGION_CONFIG;
  }

  override prepareRequestToConfirmVendor(): IVendorOAuthConfirmationRequest {
    return {
      ...super.prepareRequestToConfirmVendor(),
      sellingPartnerId: `${localStorage.getItem('selling_partner_id')}`
    };
  }
}
